
export const codes = {
  ERR_INVALID_PARAMETERS: 'ERR_INVALID_PARAMETERS'
}
